var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgProfilePencil = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 25C0 11.1929 11.1929 0 25 0C38.8071 0 50 11.1929 50 25C50 38.8071 38.8071 50 25 50C11.1929 50 0 38.8071 0 25Z",
    fill: "url(#paint0_linear_558_44560)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9395 16.6758L14.1818 30.4469C14.1126 30.5164 14.0626 30.6042 14.0388 30.6984L12.5139 36.8247C12.4683 37.0091 12.5225 37.2052 12.6569 37.3398C12.7587 37.4416 12.8973 37.498 13.0391 37.498C13.0825 37.498 13.1269 37.4926 13.1702 37.4817L19.2908 35.9552C19.3862 35.9314 19.4729 35.8816 19.5421 35.8123L33.3009 22.0421L27.9395 16.6758Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7098 14.8008L35.1784 13.268C34.1549 12.2435 32.3709 12.2445 31.3486 13.268L29.4727 15.1456L34.8339 20.5118L36.7098 18.6341C37.2211 18.1226 37.5027 17.4417 37.5027 16.7176C37.5027 15.9934 37.2211 15.3126 36.7098 14.8008Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_558_44560",
    x1: 0,
    y1: 25,
    x2: 50,
    y2: 25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D5EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#389FFF"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgProfilePencil);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/profile-pencil.5936c03d8f93d6f9e4623a1464c9304b.svg";